@import '../../../../../../../constants/spacing.module.less';

.edit-address-modal-body {
  min-height: 570px;
  padding: @space-16 @space-16 @space-32;
  gap: @space-32;
}

.column {
  flex: 1;
  gap: @space-8;
}

.edit-address-footer {
  height: fit-content;
}

.edit-address-footer-buttons {
  justify-content: flex-end;
  padding: @space-16 @space-0;
}

.edit-address-footer-right-side {
  display: flex;
  gap: @space-8;
}
